module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire--red-acf9a5e3bd19aae5c96073c550ff0ad2.svg";